import { IDictionaryFieldFieldsFragment } from '../../../utils/apollo/graphqlSchema';
import { isNestedField } from '../../../utils/fields';
import { IDictionaryFieldWithRowExpand } from './types';

/**
 * Organizes the fields into a hierarchy with sub-rows. This function
 * maps fields that contain nested field metadata into a structure where each
 * field can have an array of sub-rows.
 *
 */
export const mapSubRows = (
  fields: IDictionaryFieldFieldsFragment[],
): IDictionaryFieldWithRowExpand[] => {
  const fieldsByNestedField = new Map<
    string,
    IDictionaryFieldWithRowExpand[]
  >();

  for (const field of fields) {
    if (field.nestedFieldMetadata) {
      const fieldKey = field.nestedFieldMetadata.fieldKey;
      let list = fieldsByNestedField.get(fieldKey);
      if (!list) {
        list = [];
        fieldsByNestedField.set(fieldKey, list);
      }
      list.push({ ...field, rowExpand: { hasRowExpand: false } });
    }
  }

  const fieldsWithSubRows: IDictionaryFieldWithRowExpand[] = [];
  for (const field of fields) {
    if (!field.nestedFieldMetadata) {
      if (isNestedField(field)) {
        fieldsWithSubRows.push({
          ...field,
          rowExpand: {
            hasRowExpand: true,
            subRows: fieldsByNestedField.get(field.key) ?? [],
          },
        });
      } else {
        fieldsWithSubRows.push({
          ...field,
          rowExpand: {
            hasRowExpand: false,
          },
        });
      }
    }
  }

  return fieldsWithSubRows;
};
